import * as React from "react";

const SvgLocationOn = ({ color, size }) => (
  <svg
    viewBox="0 0 25 25"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.3}
      d="M12.5 4.5c-2.76 0-5 2.24-5 5 0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"
      fill={color}
    />
    <path
      d="M12.5 2.5c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm-5 7c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88-2.08-2.67-5-7.03-5-9.88z"
      fill={color}
    />
    <path d="M12.5 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" fill={color} />
  </svg>
);

export default SvgLocationOn;
